module.exports = __webpack_public_path__ + "img/avatar1.3847dbef.png";